import { Checkbox, Input, Radio, Typography } from 'antd'
import { memo } from 'react'
import { EEnhancementImageType } from 'models/product'
import { OrangeButton } from 'components/ui'
import styles from '../AiEnhancementModal.module.scss'

interface MainProps {
  improveDescription: boolean
  setImproveDescription: (value: boolean) => void
  improveDescriptionPrompt: string
  setImproveDescriptionPrompt: (value: string) => void
  characteristics: boolean
  setCharacteristics: (value: boolean) => void
  productImage: boolean
  setProductImage: (value: boolean) => void
  imageEnhancementType: EEnhancementImageType
  setImageEnhancementType: (value: EEnhancementImageType) => void
  fullEnhancementImagePrompt: string
  setFullEnhancementImagePrompt: (value: string) => void
  handleGenerate: () => void
  scope?: 'all' | 'image'
}

const { TextArea } = Input

export const Main: React.FC<MainProps> = memo(({
  improveDescription,
  setImproveDescription,
  improveDescriptionPrompt,
  setImproveDescriptionPrompt,
  characteristics,
  setCharacteristics,
  productImage,
  setProductImage,
  imageEnhancementType,
  setImageEnhancementType,
  fullEnhancementImagePrompt,
  setFullEnhancementImagePrompt,
  handleGenerate,
  scope = 'all'
}) => {
  return (
    <div className={styles.contentWrapper}>
      {scope !== 'image' && (
        <>
          <Checkbox
            checked={improveDescription}
            onChange={(e) => setImproveDescription(e.target.checked)}
            className={styles.checkbox}
          >
            Улучшить описание
          </Checkbox>

          {improveDescription && (
            <div className={styles.textareaWrapper}>
              <TextArea
                placeholder='Модификация промта (для экспертов)'
                value={improveDescriptionPrompt}
                onChange={(e) => setImproveDescriptionPrompt(e.target.value)}
                autoSize={{ minRows: 2, maxRows: 4 }}
              />
            </div>
          )}

          <Checkbox
            checked={characteristics}
            onChange={(e) => setCharacteristics(e.target.checked)}
            className={styles.checkbox}
          >
            Характеристики
          </Checkbox>
        </>
      )}
      <Checkbox
        checked={productImage}
        onChange={(e) => setProductImage(e.target.checked)}
        className={styles.checkbox}
      >
        Картинка товара
      </Checkbox>

      {productImage && (
        <div className={styles.radioGroup}>
          <Radio.Group value={imageEnhancementType} onChange={(e) => setImageEnhancementType(e.target.value)}>
            <Radio value={EEnhancementImageType.BACKGROUND} className={styles.radioOption}>
              Только замена фона
            </Radio>

            <Radio value={EEnhancementImageType.FULL} className={styles.radioOption} style={{ marginBottom: imageEnhancementType === EEnhancementImageType.FULL ? 0 : 10 }}>
              Полное улучшение картинки
            </Radio>

            {imageEnhancementType === EEnhancementImageType.FULL && (
              <div className={styles.radioNestedContent}>
                <TextArea
                  placeholder='Модификация промта (для экспертов)'
                  value={fullEnhancementImagePrompt}
                  onChange={(e) => setFullEnhancementImagePrompt(e.target.value)}
                  autoSize={{ minRows: 1, maxRows: 3 }}
                  style={{ marginBottom: 6 }}
                />
                <Typography.Text className={styles.warningText}>
                  Не рекомендуем применять к фото и картинкам с текстом или логотипами
                </Typography.Text>
              </div>
            )}
            <Radio value={EEnhancementImageType.INFOGRAPHIC} className={styles.radioOption}>
              Полное улучшение + инфографика
            </Radio>
          </Radio.Group>
        </div>
      )}
      <OrangeButton
        size='large'
        onClick={handleGenerate}
        style={{ marginTop: 10 }}
      >
        Сгенерировать
      </OrangeButton>
    </div>
  )
})
